import { Noto_Sans_KR, Noto_Sans_Thai, Noto_Sans } from 'next/font/google';
import clsx from 'clsx';

const notoSans = Noto_Sans({
  subsets: ['latin'],
  weight: ['400', '700'],
  display: 'swap',
});

const notoSansKR = Noto_Sans_KR({
  weight: ['400', '700'],
  display: 'swap',
  preload: false,
});

const notoSansThai = Noto_Sans_Thai({
  weight: ['400', '700'],
  display: 'swap',
  preload: false,
});

export default function NotAuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div
      className={clsx(
        notoSansKR.className,
        notoSansThai.className,
        notoSans.className,
      )}
    >
      <div>{children}</div>
    </div>
  );
}
